import PencilButton from './PencilButton';

const credentialsFormatters = {
  formatAction: (_, { aggregatorID }) => <PencilButton credentialId={aggregatorID} />,
};

export { credentialsFormatters };
